// src/auth/token.js
import { getAuth, onAuthStateChanged } from 'firebase/auth';

export function authReady(timeoutMs = 8000) {
  const auth = getAuth();
  if (auth.currentUser) return Promise.resolve(auth.currentUser);

  let unsub;
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      if (unsub) unsub();
      resolve(null);
    }, timeoutMs);

    unsub = onAuthStateChanged(
      auth,
      (user) => {
        clearTimeout(timer);
        if (unsub) unsub();
        resolve(user);
      },
      (err) => {
        clearTimeout(timer);
        if (unsub) unsub();
        reject(err);
      }
    );
  });
}
